import React from 'react';
import SvgIcon from 'e100-react-components/lib/components/SvgIcon';
import { IProps } from 'e100-react-components/lib/components/SvgIcon/index';

export const FiberManualRecord = (props: IProps) => (
  <SvgIcon {...props}>
    <circle cx="12" cy="12" r="8"></circle>    
  </SvgIcon>
);
